export const CONSTANT = {
  CONFIG: {
    ENVIRONMENT: {
      SANDBOX: 'Sandbox',
      STAGE: 'Stage',
      PRODUCTION: 'Production',
      ITF: 'ITF'
    }
  },
  OTP_METHODS: [
    'Phone',
    'Email'
  ],
  CODE_LENGTH: 6,
  PAN_ENC: {
    MASTERCARD: {
      ENCRYPTION_KEY_ID: 'src-fpan-encryption',
      ENCRYPTION_CONTENT_ALGO: 'A128GCM',
      ENC_ALGO: 'RSA-OAEP-256'
    }
  }
}

export const SDK_METHODS = {
  BOOTSTRAP: 'bootstrap',
  INIT: 'init',
  ISRECOGNIZED: 'isRecognized',
  ID_LOOKUP: 'identityLookup',
  INITIATE_ID_VALIDATION: 'initiateIdentityValidation',
  COMPLETE_ID_VALIDATION: 'completeIdentityValidation',
  CHECKOUT: 'checkout',
  GET_SRC_PROFILE: 'getSrcProfile',
  DELETE_CARD: 'deleteCard'
}

export const NETWORK_LOGOS = [
  'amex',
  'visa_light',
  'mastercard',
  'discover'
]
export const CRYPTOTYPE = {
  'UCAF': 'CARD_APPLICATION_CRYPTOGRAM_SHORT_FORM',
  'NONE': 'NONE'
}
export const CRYPTOTYPE_DESCRIPTION = {
  'UCAF': 'Digital Secure Remote Payment equivalent',
  'DTD': 'Dynamic Token Verification Code equivalent',
  'NONE': 'NONE'
}
export const ENV_LOWER_ENV = {
  'Sandbox': 'Sandbox',
  'Stage': 'Stage',
  'ITF': 'ITF'
}

export const ENV_HIGHER_ENV = {
  'Sandbox': 'Sandbox',
  'Production': 'Production'
}
export const CARD_TYPES = {
  'american-express': 'amex',
  visa: 'visa',
  mastercard: 'mastercard',
  discover: 'discover'
}

export const SDK_ID_MASTERCARD = 'mastercard'
export const SDK_IDS = {
  [SDK_ID_MASTERCARD]: SDK_ID_MASTERCARD
}

export const SDK_ENUMS = {
  IdentityType: {
    emailAddress: 'EMAIL_ADDRESS',
    email: 'EMAIL',
    mobile: 'MOBILE',
    mobilePhoneNumber: 'MOBILE_PHONE_NUMBER'
  },
  IdentityProvider: {
    src: 'SRC'
  },
  SrciActionCodes: {
    newUser: 'NEW_USER',
    authFailed: 'AUTH_FAILED',
    authSkipped: 'AUTH_SKIPPED'
  }
}
